import React from 'react';
import JobsContainer from '../../components/JobsContainer';
import SearchContainer from '../../components/SearchContainer';

const AllJobs = () => {
  return (
    <>
      <SearchContainer />
      <JobsContainer />
    </>
  );
};

export default AllJobs;
